/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Source_AutofillInputs */

const cs_draft_source_autofill = /** @type {(inputs: Draft_Source_AutofillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automaticky`)
};

const en_draft_source_autofill = /** @type {(inputs: Draft_Source_AutofillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autofill`)
};

/**
* | output |
* | --- |
* | "Autofill" |
*
* @param {Draft_Source_AutofillInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_source_autofill = /** @type {((inputs?: Draft_Source_AutofillInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Source_AutofillInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_source_autofill(inputs)
	return cs_draft_source_autofill(inputs)
});